import { RootLayout } from '@porotutu/react/components/RootLayout/RootLayout'
import { navGroupsFor } from '@porotutu/react/components/Sidebar/navGroups'
import { Sidebar } from '@porotutu/react/components/Sidebar/Sidebar'
import type { ReactNode } from 'react'
import { useSession, useSignOut } from '@/session'
import { NAV_GROUPS, NAV_ICONS } from './navigation'
import { NotificationBell } from './NotificationBell'

export function Layout({ children }: { children: ReactNode }) {
  const session = useSession()
  const signOut = useSignOut()

  return (
    <RootLayout
      sidebar={(onNavigate) => (
        <Sidebar
          groups={navGroupsFor(NAV_GROUPS, { ...session, icons: NAV_ICONS })}
          home="/dashboard"
          mark="C"
          fallback={session.t('layouts.main.brand_fallback')}
          onSignOut={signOut}
          onNavigate={onNavigate}
        />
      )}
      actions={
        <>
          <NotificationBell />
        </>
      }
      profilePath="/profile"
      profileLabelKey="crm.profile.show.title"
    >
      {children}
    </RootLayout>
  )
}
